module.exports = __webpack_public_path__ + "static/assem2-2f0e91c5d2a78c6179523e2e989d0e33.gif";